/** Used in Profiles and Insights to mark the view chosen to display results*/
export enum DisplayView {
  grid = 'grid',
  list = 'list',
}
